import { PaintCollection } from "@omni/types/api/paintColors/bff/paintCollection.model";

export const $PaintCollectionModuleName = "paintCollection";

export type TPaintCollectionState = { collection?: PaintCollection | null };
